module.exports = __webpack_public_path__ + "img/elementlengths_jas.a0fd6517.png";